import React from 'react';
import { toast } from 'react-toastify';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import transferService from '../../services/transferService';
import { confirm } from '../common/modals/confirmService';
import PageTitle from '../common/PageTitle';
import organizationService from '../../services/organizationService';
export default class Transfers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.organizationId,
            name: '',
            transferTo: '',
            transfers: [],
            organization: {}
        }
        this.handleChangeTransfer = this.handleChangeTransfer.bind(this);
        this.handleSubmitTransfer = this.handleSubmitTransfer.bind(this);
        this.handleDeclineStatus = this.handleDeclineStatus.bind(this);
    }

    componentDidMount() {
        this.loadOrganizationById()
    }

    loadMyApprovedOrganizationTransfer() {
        transferService.loadApprovedFromOrganizationTransfer().then(response => {
            this.setState({
                transfers: response.transfers
            })
        }).catch(error => {
        })
    }

    loadOrganizationById() {
        organizationService.getById(this.state.id).then(result => {
            this.setState({
                organization: result
            })
            this.loadMyApprovedOrganizationTransfer()
        }).catch(error => {
            toast.error("Error loading organization", this.options)
        });
    }

    handleChangeTransfer = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmitTransfer = event => {
        transferService.createTransferRequest(this.state.transferTo, this.state.organization._id, this.state.organization.name).then(response => {
            toast.success("Transfer is successfully created!", this.options);
        }).catch(error => {
            toast.error(error.response, this.options)
        })
    }

    handleDeclineStatus(id) {
        confirm('Are you sure you want to decline request?').then(() => {
            transferService.declineTransferRequest(id).then(response => {
                toast.success("Transfer is declined successfully!", this.options);
                this.loadMyApprovedOrganizationTransfer();
            }).catch(error => {
                toast.error(error.response, this.options)
            })
        }, () => {
        });
    }

    render() {
        const { transferTo, transfers, organization } = this.state;
        return (
            <div className="">
                <Row noGutters className="page-header py-4">
                    <PageTitle sm="4" title='Connect request' subtitle="MANAGE CONNECT REQUEST" className="text-sm-left" />
                    <Col sm="12" md="12" lg="8" xl="6">
                        <p className="m-0 light-grey">
                            This page helps the selected organization to connect to another organization outside your account under AirTouch® Office Connect service. Office Connect service can link up to 5 organizations to share organization extension lists in Office Connect organization contact list inside your app and among extensions from 5 organizations can communicate with each other by intercom, video call, organization chats.
                        </p>
                    </Col>
                </Row>
                <Row >
                    <Col sm="12" md="12" lg="8">
                        <Card className="mb-4 card-custom">
                            <div className="group-tranfer">
                                <CardHeader className="border-bottom">
                                    <h6 className="m-0">Create organization transfer for organization  {organization.name}</h6>
                                </CardHeader>
                                <CardBody className="p-20 pb-3 table-responsive">
                                    <form onSubmit={this.handleSubmitTransfer}>
                                        <div className="form-group">
                                            <label className="text-white" htmlFor="transferTo">Send transfer request to user:</label>
                                            <div className="custom-form-inline">
                                                <input id='transferTo'
                                                    className="form-control bordered"
                                                    type="text" name="transferTo"
                                                    value={transferTo}
                                                    placeholder="Enter user's username..."
                                                    onChange={this.handleChangeTransfer} />
                                                <div>
                                                    <button className="btn btn-lightblue  bt-w-95">Send</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <table className="table mb-0">
                                        <thead className="lightblue-bg">
                                            <tr>
                                                <th className="border-0">Username </th>
                                                <th className="border-0">Status</th>
                                                <th className="border-0 text-center">Decline </th>
                                            </tr>
                                        </thead>
                                        {transfers.length > 0 ?
                                            <tbody>
                                                {transfers.map((transfer, i) => (
                                                    <tr key={i}>
                                                        <td>{transfer.to}</td>
                                                        {transfer.status === 1 ? <td>Pending</td> : null}
                                                        <td className="text-center"> <i className="material-icons red  hover-el" onClick={() => this.handleDeclineStatus(transfer._id)}>clear</i></td>
                                                    </tr>
                                                ))}
                                            </tbody> : null}
                                    </table>
                                </CardBody>
                            </div>
                        </Card>

                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/transferComponent/transfers.js